// Extrai a mensagem legível de um erro da API, já desembrulhado pelo
// Http.resolveErros (que rejeita com o corpo da resposta).
//
// A API devolve dois formatos de erro 400:
// - Envelope do projeto (ApiControllerBase.Response / ResponseBadRequest):
//     { success: false, errors: [{ ErrorCode, Message }] }
// - ValidationProblemDetails, gerado pelo [ApiController] quando a validação do
//   modelo (DataAnnotations) falha antes de a action rodar:
//     { title, status, errors: { Campo: ['mensagem', ...] } }
// Qualquer outro formato (inclusive o Error lançado pelo adaptador mockado)
// cai no fallback.
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const errors = (error as { errors?: unknown } | null)?.errors;

  if (Array.isArray(errors)) {
    const message = errors.find((item) => typeof item?.Message === 'string')?.Message;
    return message || fallback;
  }

  if (errors && typeof errors === 'object') {
    const messages = Object.values(errors as Record<string, unknown>)
      .flat()
      .filter((message): message is string => typeof message === 'string');
    return messages.length > 0 ? messages.join(' ') : fallback;
  }

  return fallback;
};
